import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";

export async function deleteAncillaryFromOffer(
  bookingId: string,
  bookingOfferId: string,
  ancillaryId: string,
  showLoaderForThisRequest: boolean = true
): Promise<IApiResponse<any>> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.deleteAncillaryFromOffer(
    bookingId,
    bookingOfferId,
    ancillaryId
  );
  return await apiRequest<any>(endpoint, "DELETE", {}, "none", undefined, undefined, showLoaderForThisRequest);
}


